<div class="col full-height layout-row"
     (contextmenu)="onRightClick($event)"
     (mouseenter)="onHover(true)"
     (mouseleave)="onHover(false)">

  <!--  <div *ngIf="item.handle"-->
  <!--    class="drag-handle align-self-center mx-3 my-0"-->
  <!--    dndHandle-->
  <!--    matListItemIcon>-->
  <!--    <bringoz-icon icon-name="account"></bringoz-icon>-->
  <!--  </div>-->

  <div *ngIf="(task.taskType !== 'Internal')" class="flex-10 layout-column">

    <div *ngIf="isHover" class="flex layout-column layout-align-start-center">
      <div class="flex">
        <div class="drag-wrapper">
          <ng-content></ng-content>
        </div>
<!--        <bringoz-icon iconName="drag" fill="#484848"></bringoz-icon>-->
      </div>
      <div class="task-index"
           [style.border-color]="route.color"
           [style.background]="(isHighlighted || isHover) ? route.color : (route.color + 20)"
           [style.color]="(isHighlighted || isHover) ? 'white' : route.color">
        <span class="index">{{ index }}</span>
        <span class="trip-number">{{ task.routeAnalysis?.tripNumber }}</span>
      </div>
      <div class="flex"></div>
    </div>

    <div *ngIf="!isHover" class="flex layout-column layout-align-start-center">
      <div class="flex index-border" [style.background-color]="route.color"></div>
      <div class="task-index"
           [style.border-color]="route.color"
           [style.background]="isHighlighted ? route.color : (route.color + 20)"
           [style.color]="isHighlighted ? 'white' : route.color">
        <span class="index">{{ index }}</span>
        <span class="trip-number">{{ task.routeAnalysis?.tripNumber }}</span>
      </div>
      <div class="flex index-border" [style.background-color]="route.color"></div>
    </div>

  </div>

  <div class="flex layout-row layout-wrap">

    <!--Title Row-->
    <div class="flex-100 layout-row layout-align-start-center gap-5 task-title">

      <app-bringoz-checkbox [isChecked]="isSelected"
                            (clickEvent)="onToggle.emit(!isSelected)">
      </app-bringoz-checkbox>

      <app-bringoz-status-tag *ngIf="settings?.columns?.status"
                              [status]="task.status"
                              [isSmall]="true">

      </app-bringoz-status-tag>

      <span *ngIf="task.taskType !== 'BundledStopover'"
            [ngClass]="task.taskSpec.purpose"
            class="status-header br-body-1">
        {{ 'TASK_PURPOSE.' + task.taskSpec.purpose | translate }}
      </span>

      <span *ngIf="task.taskType === 'BundledStopover'"
            class="status-header br-body-1"
            [ngClass]="task.taskSpec.purpose">{{ 'Multi' | translate }} {{ 'TASK_PURPOSE.' + task.taskSpec.purpose | translate }}
        ({{ task.bundledTaskList?.length || task.bundledTaskIdList?.length }})
      </span>

      <app-service-link *ngIf="task.taskType === 'Stopover'"
                        [serviceType]="purposeToServiceType[task.taskSpec.purpose]"
                        [id]="task.serviceId"
                        [externalId]="task.serviceExternalId"
                        isAllowCopyButton="true">
      </app-service-link>

      <!--      <div ng-if="$ctrl.task.serviceDisplayId" class="text-ellipsis" style="line-height: 15px">-->
      <!--        <span class="br-caption-2">{{$ctrl.task.serviceDisplayId}}</span>-->
      <!--      </div>-->

    </div>

    <!--    &lt;!&ndash;Start/End Row&ndash;&gt;-->
    <!--    <div *ngIf="(task.taskType === 'Internal')"-->
    <!--         class="flex-100 layout-row layout-align-start-center info-row gap-5">-->
    <!--      <bringoz-icon iconName="location-pin-outline"-->
    <!--                    classSize="md"-->
    <!--                    fill="#484848">-->

    <!--      </bringoz-icon>-->
    <!--      <span class="br-body-1">{{'TASK_PURPOSE.' + task.taskSpec.purpose | translate}}</span>-->
    <!--    </div>-->

    <!--Account Row-->
    <div *ngIf="settings?.columns?.account && task.taskType !== 'Internal'"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="account"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Account' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-demand-account-link *ngIf="accountReferences?.length === 1"
                               class="flex br-body-1 text-ellipsis"
                               [account]="accountReferences[0]"
                               [isDisableTooltip]="true"
                               [ngbTooltip]="accountsTooltip"
                               tooltipClass="routes-panel-route-view-task-item-accounts-tooltip"
                               openDelay="300" triggers="hover" container="body">

      </app-demand-account-link>


      <span *ngIf="accountReferences?.length > 1"
            class="br-body-1 text-ellipsis"
            [ngbTooltip]="accountsTooltip"
            tooltipClass="routes-panel-route-view-task-item-accounts-tooltip"
            openDelay="300" triggers="hover" container="body">
          {{accountReferences.length === 1 ? ('X_ACCOUNT' | translate: {length: accountReferences.length}) : ('X_ACCOUNTS' | translate: {length: accountReferences.length}) }}
        </span>

      <ng-template #accountsTooltip>
        <div class="col" style="min-width: 400px;">
          <div class="flex layout-row">
            <div class="flex br-caption-1" style="text-align: start;">{{'Account Name' | translate}}:</div>
            <div class="flex br-caption-1" style="text-align: start;">{{'Address' | translate}}:</div>
            <div class="flex br-caption-1" style="text-align: start;">{{'Account External ID' | translate}}:</div>
            <div class="flex-15 br-caption-1" style="text-align: start;">{{'Pallets' | translate}}:</div>
          </div>

          <div class="flex layout-row" *ngFor="let reference of accountReferences">
            <div class="flex" style="text-align: start;">
              <span>{{reference.name}}</span>
            </div>

            <div class="flex layout-align-center-center text-ellipsis" style="text-align: start;">
              <span>{{ reference.address ? (reference.address | bringozAddressCity) : '---'}}</span>
            </div>

            <div class="flex layout-align-center-center text-ellipsis" style="text-align: start;">
              <span>{{reference.externalId || '---' }}</span>
            </div>

            <div class="flex-15 layout-row layout-align-start-center gap-5">
              <span>{{reference.pallets | number: '1.0-2'}}</span>
              <bringoz-icon iconName="pallets" classSize="sm"></bringoz-icon>
            </div>

          </div>
        </div>
      </ng-template>
    </div>

    <!--Address Row-->
    <div *ngIf="settings?.columns?.address"
         class="flex-100 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="location-pin-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Address' | translate"
                    openDelay="300">

      </bringoz-icon>

      <!--      <app-task-purpose [purpose]="task.taskSpec.purpose" firstLetterOnly="true"></app-task-purpose>-->
      <span class="br-body-1 text-ellipsis">{{ task.taskSpec.address | bringozAddress }}</span>
    </div>

    <!--Time Window Row-->
    <div *ngIf="settings?.columns?.timeWindow"
         class="flex-100 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="time-window-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Time Window' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ task.taskSpec | timeWindow }}</span>
    </div>

    <!--ETA Row-->
    <div *ngIf="settings?.columns?.eta"
         class="flex-100 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="eta"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'ETA' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ task.routeAnalysis | bringozDate:'eta':true }}</span>
      <!--      <app-task-planned-eta [task]="task"-->
      <!--                            [timeZoneId]="task.taskSpec.address?.zoneIdName"-->
      <!--                            [configZoneId]="configZoneId"-->
      <!--                            class="font-weight-500">-->

      <!--      </app-task-planned-eta>-->
    </div>

    <!--ETD Row-->
    <div *ngIf="settings?.columns?.etd"
         class="flex-100 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="etd"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'ETD' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ task.routeAnalysis | bringozDate:'etd':true }}</span>
    </div>

    <!--Service Time Row-->
    <div *ngIf="settings?.columns?.serviceTime && task.taskType !== 'Internal'"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="timer-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Service Time' | translate"
                    openDelay="300">

      </bringoz-icon>

      <div *ngIf="!task.taskSpec?.detailedServiceTime"
           class="md-tiny layout-row layout-align-start-center">
        {{ task.taskSpec?.serviceTime | bringozTimeConvert: true }}
      </div>

      <app-task-detailed-service-time *ngIf="!!task.taskSpec?.detailedServiceTime"
                                      class="margin-left-5"
                                      [fontSize]="'md-tiny'"
                                      [isAllowEdit]="false"
                                      [detailedServiceTime]="task.taskSpec?.detailedServiceTime">
      </app-task-detailed-service-time>
    </div>

    <!--Contacts Row-->
    <div *ngIf="settings?.columns?.contact && task.taskType !== 'Internal'"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="contact-circle"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Contacts' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ task.taskSpec.contact.name || '---' }}</span>
    </div>


    <!--Pro Number Row-->
    <div *ngIf="settings?.columns?.proNumber && task.taskType !== 'Internal'"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="hash"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Pro Number' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span *ngIf="proNumbers.length === 0"> --- </span>
      <app-bringoz-items-list-display *ngIf="proNumbers.length > 0" [items]="proNumbers" [maxItems]="1" [isTransparentBackground]="true" [canCopy]="true">
      </app-bringoz-items-list-display>
    </div>

    <!-- Price Row -->
    <div *ngIf="settings?.columns?.price"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="dollar-circle"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Price' | translate"
                    openDelay="300">
      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ task | taskCourierPrice }}</span>
    </div>

    <!-- Program Type Row -->
    <div *ngIf="settings?.columns?.programType"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="hash"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Program Type' | translate"
                    openDelay="300">
      </bringoz-icon>
      <span> {{ task.serviceInfo?.pricePlanType ? programs[task.serviceInfo.pricePlanType] : '---' }} </span>
    </div>

    <!-- Depot External ID Row -->
    <div *ngIf="settings?.columns?.depotExternalId && task.taskType === 'Internal'"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="hash"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Depot External ID' | translate"
                    openDelay="300">
      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ task.taskSpec.depotReference?.externalId || '---' }}</span>
    </div>

    <!--    &lt;!&ndash;SLA Row&ndash;&gt;-->
    <!--    <div *ngIf="settings?.columns?.sla && task.taskType !== 'Internal'"-->
    <!--         class="flex-50 layout-row info-row layout-align-start-center gap-5 text-ellipsis">-->
    <!--      <span class="br-body-1 fon-weight-600">SLA</span>-->
    <!--      <span class="br-body-1">{{job | bringozDate: 'sla'}}</span>-->
    <!--      <span class="br-body-1">{{job | bringozTime: 'sla'}}</span>-->
    <!--    </div>-->

    <!--Labels Row-->
    <div *ngIf="settings?.columns?.labels && task.taskType !== 'Internal'"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="label-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Labels' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-labels-display [labels]="labels"
                                  maxItems="1">

      </app-bringoz-labels-display>
      <span *ngIf="!labels?.length" class="br-body-1 text-ellipsis">---</span>
    </div>

    <!--Packages Row-->
    <div *ngIf="settings?.columns?.packages && task.taskType !== 'Internal'"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="package-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Packages' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-packages-items-display-list *ngIf="task.packageList?.length && task.packageList[0].items?.length"
                                               class="flex"
                                               [items]="task.packageList[0].items">

      </app-bringoz-packages-items-display-list>
    </div>

    <!--Barcodes Row-->
    <div *ngIf="settings?.columns?.barcodes && task.taskType !== 'Internal'"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="barcode"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Barcodes' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-items-list-display [items]="barcodesList" maxItems="1"></app-bringoz-items-list-display>
    </div>

    <!--Relations Row-->
    <div *ngIf="settings?.columns?.relations"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <app-task-relations-indicator [relations]="relations"
                                    (onClick)="onRelationsClick.emit($event)">
      </app-task-relations-indicator>
    </div>

    <!--Load - Weight-->
    <div *ngIf="settings?.load?.weight && task.taskType !== 'Internal'"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="weight"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Weight' | translate"
                    openDelay="300">

      </bringoz-icon>
      <div class="flex layout-row text-ellipsis br-body-1" *ngIf="task.packageList?.length">
        <span *ngIf="task.packageList?.length" class="br-body-1 text-ellipsis">{{ task.packageList | packageWeight:true }}</span>
      </div>
    </div>

    <!--Load - Volume-->
    <div *ngIf="settings?.load?.volume && task.taskType !== 'Internal'"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="volume"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Volume' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span *ngIf="task.packageList?.length" class="br-body-1 text-ellipsis">{{ task.packageList | packageVolume:true }}</span>
    </div>

    <!--Load - Packages-->
    <div *ngIf="settings?.load?.packages && task.taskType !== 'Internal'"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="package-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Packages' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ task.packageList | packageTotalItems }}</span>
    </div>

    <!--Load - Value-->
    <div *ngIf="settings?.load?.value && task.taskType !== 'Internal'"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="dollar-circle"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Value' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ task.packageList | packageTotalValue: true }}</span>
    </div>

    <!--Load - Pallets-->
    <div *ngIf="settings?.load?.pallets && task.taskType !== 'Internal'"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="pallets"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Pallets' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ task.packageList | packagePallets }}</span>
    </div>

    <!--Load - Spots-->
    <div *ngIf="settings?.load?.spots && task.taskType !== 'Internal'"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="spot"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Spots' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ task.packageList | packageSpots }}</span>
    </div>

    <!--    &lt;!&ndash;Capacity Row&ndash;&gt;-->
    <!--    <div *ngIf="settings?.capacity && capacity" class="flex-50 layout-row layout-align-start-center info-row gap-5">-->
    <!--      <bringoz-icon [iconName]="capacity.icon"-->
    <!--                    classSize="md">-->

    <!--      </bringoz-icon>-->
    <!--      <app-bringoz-capacity-bar class="flex" [value]="capacity.percentage">-->

    <!--      </app-bringoz-capacity-bar>-->
    <!--      <span class="br-body-1">{{capacity.percentage}}%</span>-->
    <!--    </div>-->


  </div>

</div>
